import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { DEFAULT_TYPE } from 'components/Routes/Admin/contstants';
import { useLoadTranslations } from 'hooks/useLoadTranslations';
import { resetPageDataAction, setPageDataAction } from 'store/page';
import { getPageDataThunk } from 'store/page/thunks';

import useQuery from '../useQuery';

export function usePageHook(pageData) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { pageId: paramsPageId } = useParams();
  const pageId = paramsPageId || pageData.id;

  const dispatch = useDispatch();
  const query = useQuery();
  const type = pageData.type || query.get('type') || DEFAULT_TYPE;
  useLoadTranslations();

  useEffect(() => {
    const setPageData = async () => {
      setLoading(true);

      if (pageId > 0) {
        await dispatch(getPageDataThunk(pageId)).catch(() => setError(true));
      } else {
        dispatch(setPageDataAction({ type }));
      }

      setLoading(false);
    };

    setPageData();

    return () => {
      dispatch(resetPageDataAction());
    };
  }, [dispatch, pageId]);

  return { loading, error };
}
